import React from 'react';
import { Button } from 'antd';

const OpenChangeData = ({ onChange }) => {
  return (
    <Button
      onClick={onChange}
      type="primary"
    >
      Изменить
    </Button>
  );
};

export default OpenChangeData;
